import { render } from "./ProductFilterBody.vue?vue&type=template&id=6afced68"
import script from "./ProductFilterBody.vue?vue&type=script&lang=js"
export * from "./ProductFilterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__